import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentCardModel, PaymentCardTypes } from '../paymentcard.model';
import { PaymentCardService } from '../paymentcard.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { PaymentCardDialogDeleteComponent } from '../paymentcard-dialog-delete.component';
import { BankAccountModel } from '../../bancos/bankaccount.model';
import { BankAccountService } from '../../bancos/bankaccount.service';
import { DummyComponent } from '../../../../shared/dummy.component';
import { PaymentCardComponent } from '../paymentcard.component';
import { TarjetaDebitoConst } from '../const';
import { TableService } from '../../../../shared/components/table/table.service';
import { consts } from '../../../../consts';
import { Utils } from '../../../../shared/utils';

@Component({
    selector: 'convfact-tarjeta-debito-list',
    templateUrl: './tarjeta-debito-list.component.html',
    styleUrls: [],
    standalone: false
})
export class TarjetaDebitoListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public dataSource: PaymentCardModel[] = [];
  public bankAccounts: BankAccountModel[] = [];
  public empty = false;
  public ready = false;
  public headerTable: any[] = TarjetaDebitoConst.headerTable;

  constructor(
    private paymentCardService: PaymentCardService,
    private bankAccountService: BankAccountService,
    private router: Router,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    private tableService: TableService,
    public snackBar: MatSnackBar,
  ) { }

  public create(uid: string = undefined): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    uid = null;
    this.dialog.open(PaymentCardComponent, {
      data: { uid: uid, paymentCardType: PaymentCardTypes.Tarjeta_Debito }
    })
    .afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dummy.redirectTo(this.router.url);
      }
    });
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PaymentCardDialogDeleteComponent, {
      data: { uid: uid, paymentCardType: PaymentCardTypes.Tarjeta_Debito }
    })
    .afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dummy.redirectTo(this.router.url);
      }
    });
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PaymentCardComponent, {
      data: { uid: uid, paymentCardType: PaymentCardTypes.Tarjeta_Debito }
    })
    .afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dummy.redirectTo(this.router.url);
      }
    });
  }


  ngOnInit() {
    this.getList();
  }

  public getList() {
    this.paymentCardService.getList(PaymentCardTypes.Tarjeta_Debito, this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.bankAccountService.getList().then(response => {
          this.bankAccounts = response.list;
          this.dataSource.forEach(paymentCard => {
            this.bankAccounts.forEach(bankAccount => {
              if (paymentCard.bankAccountUid === bankAccount.uid) {
                paymentCard.bank = bankAccount.bank;
                paymentCard.iban = bankAccount.iban;
              }
            });
          });
        });
        this.ready = true;
      }
    );
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }


}
